<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <BaseMyCard
      v-bind="$attrs"
      v-on="$listeners"
      v-resize="onResize"
      :hover="hover"
      class="ma-2"
      :scale="1.02"
    >
      <v-container class="px-8 py-0" fluid>
        <v-row class="space-between flex-nowrap">
          <v-col :class="`d-flex align-center ${ $vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'}`">
            <div class="d-flex flex-column align-center justify-center" >
              <v-list-item-avatar
                size="64"
                :color="!postulant.informacion_personal.profile_image ? 'primary' : ''"
                class="d-flex justify-center"
              >
                <v-img
                  v-if="!!postulant.informacion_personal.profile_image"
                  :src="`${host}${postulant.informacion_personal.profile_image}`" :alt="postulant.informacion_personal.logo"
                ></v-img>
                <span v-else class="white--text headline font-weight-bold">
                  {{ initialsName }}
                </span>
              </v-list-item-avatar>
              <v-chip
                small
                :class="['px-4', { 'success--text': postulant.preferencia_salarial }, 'float-right', 'font-weight-bold']"
                :color="postulant.preferencia_salarial ? 'success lighten-5' : ''"
              >
                <span v-if="!postulant.preferencia_salarial">
                  $ 0
                </span>
                <div v-else class="d-flex align-center">
                  <v-icon small>mdi-currency-usd</v-icon>
                  <span class="font-weight-bold">{{ postulant.preferencia_salarial.salario }}</span>
                </div>
              </v-chip>
            </div>
            <v-list-item-content>
              <v-list-item-subtitle class="font-weight-ligth grey--text" style="white-space: normal">
                <span class="caption font-weight-ligth grey--text">
                  {{ !age ? 'Sin edad establecida' : `${age} años` }}
                </span>
              </v-list-item-subtitle>
              <v-list-item-title class="subtitle font-weight-bold mb-1">
                {{ postulant.informacion_personal.nombres }} {{ postulant.informacion_personal.apellidos }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="postulant.informacion_contacto" class="font-weight-ligth grey--text" style="white-space: normal">
                <v-icon small >mdi-map-marker-outline</v-icon>
                {{ postulant.informacion_contacto.provincia }}, {{ postulant.informacion_contacto.ciudad }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="postulant.experiencia_laborales.length" class="font-weight-ligth grey--text d-flex align-center" style="white-space: normal">
                <v-icon small class="mr-2">mdi-briefcase-outline</v-icon>
                <div>
                  <div>
                    {{ postulant.experiencia_laborales[postulant.experienciaLaboralesIndex].puesto }}
                    {{ postulant.experiencia_laborales[postulant.experienciaLaboralesIndex].nivel_experiencia }}
                    en
                    {{ postulant.experiencia_laborales[postulant.experienciaLaboralesIndex].nombre_empresa }}
                    <span class="font-weight-bold">
                      (<v-icon small class="mr-1" color="grey">mdi-clock-outline</v-icon>
                        {{ getStartDateAndEndDateFormat(postulant.experiencia_laborales[postulant.experienciaLaboralesIndex].fecha_inicio, postulant.experiencia_laborales[postulant.experienciaLaboralesIndex].fecha_fin) }})
                    </span>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <div v-if="postulant.experiencia_laborales.length > 1">
                  <v-btn
                    :disabled="!(postulant.experienciaLaboralesIndex > 0)"
                    x-small
                    title
                    depressed
                    color="deep-orange lighten-5"
                    class="mr-2"
                    @click.stop="postulant.experienciaLaboralesIndex -= 1"
                  >
                    <v-icon small color="primary">mdi-arrow-left-bold</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="!(postulant.experienciaLaboralesIndex < postulant.experiencia_laborales.length - 1)"
                    x-small
                    title
                    depressed
                    color="deep-orange lighten-5"
                    @click.stop="postulant.experienciaLaboralesIndex += 1"
                  >
                    <v-icon small color="primary">mdi-arrow-right-bold</v-icon>
                  </v-btn>
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else class="font-weight-ligth grey--text d-flex" style="white-space: normal">
                <v-icon small class="mr-2">mdi-briefcase-outline</v-icon>
                <div>
                  No posee experiencias laborales cargadas
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="postulant.educacion.length" class="font-weight-ligth grey--text d-flex align-center" style="white-space: normal">
                <v-icon small class="mr-2">mdi-school-outline</v-icon>
                <div>
                  <div>
                    {{ postulant.educacion[postulant.educacionIndex].titulo_carrera }}
                    en
                    {{ postulant.educacion[postulant.educacionIndex].institucion }}
                    <span class="font-weight-bold">
                      ({{ postulant.educacion[postulant.educacionIndex].estado }})
                    </span>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <div v-if="postulant.educacion.length > 1">
                  <v-btn
                    :disabled="!(postulant.educacionIndex > 0)"
                    x-small
                    title
                    depressed
                    color="deep-orange lighten-5"
                    class="mr-2"
                    @click.stop="postulant.educacionIndex -= 1"
                  >
                    <v-icon small color="primary">mdi-arrow-left-bold</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="!(postulant.educacionIndex < postulant.educacion.length - 1)"
                    x-small
                    title
                    depressed
                    color="deep-orange lighten-5"
                    @click.stop="postulant.educacionIndex += 1"
                  >
                    <v-icon small color="primary">mdi-arrow-right-bold</v-icon>
                  </v-btn>
                </div>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else class="font-weight-ligth grey--text d-flex" style="white-space: normal">
                <v-icon small class="mr-2">mdi-school-outline</v-icon>
                <div>
                  No posee eestudios cargadas
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
            <!-- <v-spacer></v-spacer>
            <div class="d-flex flex-column align-end">
              <v-chip
                label
                :class="['px-4', { 'success--text': applicant.salario_pretendido }, 'float-right']"
                :color="applicant.salario_pretendido ? 'success lighten-5' : ''"
              >
                <span v-if="!applicant.salario_pretendido">
                  No posee salario
                </span>
                <div v-else class="d-flex align-center">
                  <v-icon small>mdi-currency-usd</v-icon>
                  <span class="font-weight-bold">{{ applicant.salario_pretendido }}</span>
                </div>
              </v-chip>
              <div class="caption grey--text mt-1 font-weight-bold">
                <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                {{ timeElapsed(applicant.createdAt) }}
              </div>
            </div> -->
          </v-col>
          <v-col
            cols="auto"
            class="text-center pl-0"
          >
            <v-row
              class="flex-column ma-0"
            >
              <v-col class="px-0 py-0">
                <v-menu offset-y left min-width="220">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-btn icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item-group color="primary">
                      <v-list-item
                        target="_blank"
                        :to="{ name: 'company app notices print curriculum applicant', params: { postulante: postulant.usuario } }"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon small>mdi-printer</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Imprimir HV</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <a
                        v-if="postulant.documentos"
                        style="text-decoration: none"
                        :href="postulant.documentos.documento"
                        :download="postulant.documentos.nombre"
                        target="_blank"
                      >
                        <v-list-item>
                          <v-list-item-icon class="mr-2">
                            <v-icon small>mdi-download</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>Descargar documentos</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </a>
                      
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col class="px-0 py-0">
                <div v-if="postulant.informacion_personal.tiene_discapacidad" style="cursor: auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small>mdi-human-wheelchair</v-icon>
                    </template>
                    <span>Persona con discapacidad</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </BaseMyCard>
  </v-hover>
</template>

<script>
import { windowSizeMixin } from '@/mixin/windowSizeMixin.js';
import config from '@/config';
export default {
  mixins: [windowSizeMixin],
  props: {
    postulant: {
      type: Object,
      required: true,
    },
  },
  computed: {
    initialsName() {
      const nombres = this.postulant.informacion_personal.nombres;
      const apellidos = this.postulant.informacion_personal.apellidos;
      if (nombres && !apellidos) return nombres[0].toUpperCase();
      else if (!nombres && apellidos) return apellidos[0].toUpperCase();
      else if (nombres && apellidos)
        return `${nombres[0].toUpperCase()}${apellidos[0].toUpperCase()}`;
      else return '';
    },
    age() {
      if (!this.postulant.informacion_personal.fecha_nacimiento) return '';
      return this.$moment().diff(this.postulant.informacion_personal.fecha_nacimiento, "years");
    },
  },
  data() {
    return {
      host: config.host,
    }
  },
  created() {
  },
  methods: {
    timeElapsed(date) {
      return this.$moment(date).fromNow();
    },
    getStartDateAndEndDateFormat(startDate, endDate) {
      const startDateFormat = this.$moment(startDate).format("MMMM DD. YYYY");
      const endDateFormat = endDate
        ? this.$moment(endDate).format("MMMM DD. YYYY")
        : "Presente";
      return `${startDateFormat} - ${endDateFormat}`;
    },
  }
}
</script>

<style>

</style>